import React, { useState } from 'react'
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle'
import * as E from './accordionElements'
import { Icon as MaxxiaIcon } from 'Maxxia/icons'
import { Icon as RemServIcon } from 'RemServ/icons'

const AccordionToggle = ({
  children,
  eventKey,
  defaultActive,
  as,
  readerText,
  expandAccordion,
  id,
  smallerTitleText,
}) => {
  const [isActive, setIsActive] = useState(defaultActive)
  const Component = as || 'div'
  const decoratedOnClick = useAccordionToggle(eventKey, () => {
    setIsActive(!isActive)
  })
  let showid = id + '.show'
  let hideid = id + '.hide'

  return (
    <Component
      onClick={decoratedOnClick}
      className="toggle"
      eventkey={eventKey}
      id={id}
    >
      <E.AccordionChildDiv smallerTitleText={smallerTitleText}>
        {' '}
        {children}
      </E.AccordionChildDiv>
      {!isActive && (
        <E.AccordionShowButton className="btn-toggle hideIcon">
          Show <span>{readerText}</span>
          {global.config.isBrandMX && (
            <MaxxiaIcon iconType="AccordionPlus" id={showid} />
          )}
          {global.config.isBrandRS && (
            <RemServIcon iconType="AccordionPlus" id={showid} />
          )}
        </E.AccordionShowButton>
      )}
      {isActive && (
        <E.AccordionShowButton className="btn-toggle hideIcon">
          Hide
          <span>{readerText}</span>
          <img src="/images/maxxia-minus.svg" alt="" id={hideid} />
          {global.config.isBrandMX && (
            <MaxxiaIcon iconType="AccordionMinus" id={showid} />
          )}
          {global.config.isBrandRS && (
            <RemServIcon iconType="AccordionMinus" id={showid} />
          )}
        </E.AccordionShowButton>
      )}
    </Component>
  )
}

export default AccordionToggle
